import { render, staticRenderFns } from "./ThankYouSection.vue?vue&type=template&id=167e19c2&"
import script from "./ThankYouSection.vue?vue&type=script&lang=js&"
export * from "./ThankYouSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports